/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import JsBarcode from "jsbarcode";
import CommonButtons from "../shared/components/CommonButtons";
import { useUser } from "src/shared/context/UserContext";
import { COMPANY_NAME } from "src/shared/utils/brand";
import noImage from "src/assets/Images/imetanic-logo.png";
import { Button } from "src/business-types/grocery/components/Button";
import { formatTerms, LABELS, ThermalPrinterTestProps } from "./PrintConfigration";
import { useDateTimeFormatter } from "src/shared/configurations/hooks/useDateTimeFormatter";

const ThermalPrint3: React.FC<ThermalPrinterTestProps> = ({ PrintData, BtnName, openPrint, isClosed, ledgerPaid, barcodeTrue, icon, className, handleAppPrint, printerCheck }) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [barcodeDataUrl, setBarcodeDataUrl] = useState<string>("");
  const { user, userConfigration } = useUser();
  const comLogo = user?.companyLogo;
  const { formatDate, formatTime } = useDateTimeFormatter();

  const roundAmount = (value: any): string => {
    if (value === undefined || value === null || value === "") return "0.00";
    const num = Number(value);
    if (isNaN(num)) return "0.00";
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  const formatNumber = (value: number) => {
    return value < 1000 ? value.toString().padStart(4, "0") : value.toString();
  };

  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);
  const parcelFeeEnabled = toBoolean(userConfigration?.parcelFeeEnabled);
  const tipsEnabled = toBoolean(userConfigration?.tipsEnabled);
  const billNoEnabled = toBoolean(userConfigration?.billNoEnabled);
  const orderIdEnabled = userConfigration?.orderIdEnabled !== undefined ? toBoolean(userConfigration?.orderIdEnabled) : true;
  const enabileTermsAndConditions = toBoolean(userConfigration?.enableTermsAndConditions);

  const formatCurrencyWithSign = (amount?: number | string) => {
    if (amount === undefined || amount === null) return "";

    const num = Number(amount);
    const sign = num < 0 ? "-" : "";
    const value = Math.abs(num);

    const rounded = Math.round((value + Number.EPSILON) * 100) / 100;

    return `${sign} ر.ق ${rounded.toFixed(2)}`;
  };

  const printHistory = () => {
    if (!PrintData?.payMentHistory || PrintData.payMentHistory.length === 0) return "";
    return `
      <div style="margin-top: 8px; border-top: 1px dashed #000; padding-top: 5px;">
        <div style="font-weight:bold; text-align:center; margin-bottom:5px;">Payment History</div>
        <table style="width:100%;">
          <thead>
            <tr style="border-bottom:1px dashed #000;">
              <th style="text-align:left;">Date</th>
              <th style="text-align:center;">Method</th>
              <th style="text-align:right;">Received</th>
              <th style="text-align:right;">Refund</th>
              <th style="text-align:right;">Bal</th>
            </tr>
          </thead>
          <tbody>
            ${PrintData.payMentHistory.map((p) =>
      `<tr>
                <td>${formatDate(p.date ?? p.payment_on)}</td>
                <td style="text-align:center;">${p.Paymentmethod}</td>
                <td style="text-align:right;">${roundAmount(p.ReceivedAmount)}</td>
                <td style="text-align:right;">${roundAmount(p.balanceReturned ?? 0)}</td>
                <td style="text-align:right;">${p.balance ? roundAmount(p.balance) : "-"}</td>
              </tr>`,
    )
        .join("")}
          </tbody>
        </table>
      </div>
    `;
  };

  // ✅ Return Details Section - shows all returned items
  const returnDetails = () => {
    if (!PrintData?.returnProducts || PrintData.returnProducts.length === 0) return "";
    const totalReturnAmount = PrintData.returnProducts.reduce((sum, product) => sum + product.netAmount, 0);

    return `
      <div style="margin-top: 8px; border-top: 1px dashed #000; padding-top: 5px;">
        <div style="font-weight:bold; text-align:center; margin-bottom:5px;">Returned Items</div>
        <table style="width:100%;">
          <thead>
            <tr style="border-bottom:1px dashed #000;">
              <th style="text-align:left; width:5%;">#</th>
              <th style="text-align:left; width:45%;">Product Name</th>
              <th style="text-align:center; width:20%;">Qty</th>
              <th style="text-align:right; width:30%;">Total</th>
            </tr>
          </thead>
          <tbody>
            ${PrintData.returnProducts.map((p, index) =>
      `<tr>
                <td style="text-align:left;">${index + 1}</td>
                <td style="text-align:left;">
                  ${p.productName}
                  ${p.arabicword ? `<br/><span style="font-size: 10px; font-style: italic; font-family: 'Tahoma', sans-serif;">${p.arabicword}</span>` : ""}
                </td>
                <td style="text-align:center;">${p.returnedQty} ${p.uom || ""}</td>
                <td style="text-align:right;">${roundAmount(p.netAmount)}</td>
              </tr>`,
    )
        .join("")}
          </tbody>
        </table>
    <div style="border-top: 1px margin-top: 5px; padding-top: 5px; border-top: 1px dashed #000;">
      <div style="display:flex; justify-content:space-between;">
        <span>Product Return Amount(ر.ق):</span> 
        <span>-${roundAmount(totalReturnAmount)}</span>
      </div>
      <div style="display:flex; justify-content:space-between;">
        <span>Return Discount(ر.ق):</span> 
        <span>+${roundAmount(PrintData.returnProducts?.[0].discount)}</span>
      </div>
      <div style="display:flex; justify-content:space-between;">
        <span>Return Delivery Fee(ر.ق):</span> 
        <span>-${roundAmount(PrintData.returnProducts?.[0].deliveryFee)}</span>
      </div>
      <div style="display:flex; justify-content:space-between;">
        <span>Return Parcel Fee(ر.ق):</span> 
        <span>-${roundAmount(PrintData.returnProducts?.[0].parcelFee)}</span>
      </div>
      <p style="border-bottom: 1px dashed #000;" />
      <div style="display:flex; justify-content:space-between; font-weight:bold;">
        <span>Total Refund Amount(ر.ق):</span> 
        <span>-${roundAmount(totalReturnAmount + PrintData.returnProducts?.[0].deliveryFee + PrintData.returnProducts?.[0].parcelFee - PrintData.returnProducts?.[0].discount)}</span>
      </div>
      </div>
    `;
  };

  const ledgerBalance = `${roundAmount(Math.abs(Number(ledgerPaid?.PreviousBalance || 0)) - (Number(ledgerPaid?.Paid || 0)) - (Number(ledgerPaid?.discount || 0)))}`;

  const ledgerList = () => {
    if (!ledgerPaid) return "";
    return `
    <div style="width:100%">
      <div style="border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px;">
      <div style="display:flex; justify-content:space-between;">
        <div>Cus.Name : ${ledgerPaid?.CustomerName}</div>
        ${billNoEnabled ? ` <div>Bill No: ${ledgerPaid?.billNo ? `${formatNumber(ledgerPaid?.billNo)}` : ""}</div>` : ""} 
      </div>
        <div style="display:flex; justify-content:space-between;">
          <div>Cus.Phone: ${ledgerPaid?.CustomerPhon}</div>
          ${ledgerPaid?.clientId ? `<div>Client ID: ${ledgerPaid?.clientId}</div>` : ""}
        </div>
        ${ledgerPaid?.createdBy ? `<div><strong>Cashier :</strong> ${ledgerPaid.createdBy}</div>` : ""}
      </div>

      <div style="border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px;">
        <div style="display:flex; justify-content:space-between;">
          <div>${LABELS.paymentType}:${ledgerPaid?.paymentMethod ?? ""}</div>
        </div>
        <div style="display:flex; justify-content:space-between;">
          <div>Date: ${formatDate(ledgerPaid?.Date ?? "")} </div> 
          <div>Time: ${formatTime(ledgerPaid?.Time ?? "")}</div>
        </div>
      </div>
      
      <div style="width: 100%; padding-bottom:6px;">
        <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          ${ledgerPaid?.previousLabel || "Prev. Balance"}:
            <span>${roundAmount(Math.abs(ledgerPaid?.PreviousBalance || 0))} ر.ق</span>
        </p>

        <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          Discount(تخفيض):
            <span>${roundAmount(Math.abs(Number(ledgerPaid?.discount) || 0))} ر.ق</span>
        </p>

        <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          ${ledgerPaid?.paidLabel || "Balance Paid"}:
            <span>${roundAmount(Math.abs(Number(ledgerPaid?.Paid) || 0))} ر.ق</span>
        </p>

       <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          <strong>${ledgerPaid?.balanceLabel || "New Balance"}:</strong>
          ${roundAmount(Math.abs(Number(ledgerBalance)))} ر.ق
        </p>
      </div>
    </div>
  `;
  };

  /** ===============================
   * Customer CONTENT
   * =============================== */

  const customerData = () => {
    return `
    <div style="border-bottom: 1px solid black; margin-bottom: 5px; padding-bottom: 3px; display: flex; flex-direction: column; gap: 1px;">
      <div>${LABELS.customerName} : ${PrintData?.CustomerName ?? ""}</div>
      <div>${LABELS.customerPhone} : ${PrintData?.CustomerPhon ?? ""}</div> 
      ${PrintData?.clientId ? `<div>${LABELS.clientId} : ${PrintData.clientId}</div>` : ""}
    </div>`;
  };

  /** ===============================
   * Order CONTENT
   * =============================== */
  const orderData = () => {
    const billNoHtml = billNoEnabled && PrintData?.billNo ? `<div><strong>${LABELS.billNo}</strong> : ${formatNumber(PrintData.billNo)}</div>` : "";
    const orderIdHtml = orderIdEnabled && PrintData?.OrderId ? `<div><strong>${LABELS.orderId}</strong> : ${PrintData?.OrderId}</div>` : "";
    const createdByHtml = `<div><strong>Cashier :</strong> ${PrintData?.createdBy || "N/A"}</div>`;

    return `
    <div style="border-bottom: 1px solid black; margin-bottom: 5px; padding-bottom: 3px; display: flex; flex-direction: column; gap: 1px;">
      ${orderIdHtml}
      ${billNoHtml}
      <div>${LABELS.date} : ${formatTime(PrintData?.Time ?? "")} ${formatDate(PrintData?.Date ?? "")}</div>
      <div>${LABELS.status} : ${PrintData?.OrderStatus ?? ""}</div>
      <div>${LABELS.paymentType} : ${PrintData?.paymentMethod ?? ""}</div>
      ${createdByHtml}
    </div>`;
  };

  /** ===============================
   * Company CONTENT
   * =============================== */

  const companyData = (comLogo: any) => {
    return `
        <div style=" justify-content: center; align-items: center; border-bottom: 1px solid black; padding-bottom: 5px; margin-bottom: 5px;">
      <div style="flex: 1; text-align: center;">
        ${user?.companyLogoAPP
        ? `<img
        src="${user?.companyLogoAPP}"
        onerror="this.src=${noImage}"
        style="width: 200px; height: 200px; border-radius: 8px; object-fit: contain;"/>`
        : `<img src="${noImage}" style="width: 200px; height: 200px; border-radius: 8px; object-fit: contain;" />`
      }
      </div>
      <div style="flex: 2; text-align: center;">
        <h1 style="font-weight: bold; font-size: 20px;">${user?.orgName}</h1>
        <h2 style="font-weight: bold; font-size: 24px;">${user?.orgArabicName}</h2>
        ${user?.businessLocation ? `<div>${user?.businessLocation}</div>` : ""}
        <div>Mob : ${user?.phones?.[0]?.phone || ""}</div>
      </div>
    </div>`;
  };

  /** ===============================
   * Order Details CONTENT
   * =============================== */

  const orderDetails = () => {
    return `
        
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        padding: 4px 2px;
        text-align: left;
      }

      /* Column Width Control */
      .col-no { width: 5%; }
      .col-name { width: 40%; }
      .col-qty { width: 25%; text-align: left; }
      .col-price { width: 15%; text-align: right; }
      .col-total { width: 15%; text-align: right; }

      /* Optional borders / spacing for rows */
      tr {
        padding-bottom: 4px;
      }
    </style>

    
    ${userConfigration.orderTableType === "Table Type:1" ? normalDesign() : ""}
    ${userConfigration.orderTableType === "Table Type:2" ? tailerShopOrderDetails() : ""}

    <div>
      <div style="display:flex; justify-content:space-between;"><span>${LABELS.subtotal}:</span> <span> ر.ق ${roundAmount(PrintData?.total)} </span></div>
      ${parcelFeeEnabled ? `<div style="display:flex; justify-content:space-between;"><span>Parcel Fee (ر.ق):</span><span>+${roundAmount(PrintData?.parcelFee)}ر.ق </span></div>` : ""}
      <div style="display:flex; justify-content:space-between;"><span>${LABELS.discount}:</span> <span> ر.ق ${roundAmount(PrintData?.discount)} </span></div>
      ${deliveryFeeEnabled && PrintData ? `<div style="display:flex; justify-content:space-between;"><span>${LABELS.deliveryFee}:</span><span>ر.ق ${roundAmount(Number(PrintData.deliveryFee))}</span></div>` : ""}
      ${tipsEnabled && PrintData ? ` <div style="display:flex; justify-content:space-between;"><span>Tip(نصيحة):</span> <span>+${roundAmount(PrintData?.Tip || PrintData?.tip)}ر.ق  </span></div>` : ""}
      <div style="display:flex; justify-content:space-between; font-weight:bold;"><span>${LABELS.total2}:</span> <span> ر.ق ${roundAmount(PrintData?.subtotal)} </span></div>
    </div>

    ${PrintData?.prvPaid !== undefined || PrintData?.prvBalance !== undefined ? `
      <div style="display:flex; justify-content:space-between;border-top: 1px solid black; padding-top:3px;">
      <span>Prev. Paid (مدفوع):</span>
      <span>ر.ق ${roundAmount(PrintData?.prvPaid)}</span>
    </div>

    <div style="display:flex; justify-content:space-between;">
      <span>Prev. Balance (المبلغ المتبقي):</span>
      <span>ر.ق ${roundAmount(PrintData?.prvBalance)}</span>
    </div>`: ""}

    <div style="display:flex; justify-content:space-between; border-top: 1px solid black; padding-top:3px;">
      <span>${LABELS.paid}:</span>
      <span> ر.ق ${roundAmount(PrintData?.Paid)} </span>
    </div>

    <div style="display:flex; justify-content:space-between;">
      <span>${LABELS.due}:</span>
      <span> ر.ق ${roundAmount(PrintData?.unpaid)} </span>
    </div>

    ${PrintData?.OSB ? `<div style="display:flex; justify-content:space-between; border-top: 1px solid black; padding-top:5px;">
      <strong>${LABELS.outstanding}:</strong> <span dir="ltr">${formatCurrencyWithSign(PrintData?.OSB)}</span>` : ""}
    </div>`;
  };

  const tailerShopOrderDetails = () => {
    return `
    <div style = "border-bottom: 1px dashed #000;">
    <div style="font-weight:bold;">Items:</div>
    <hr/>

    ${PrintData?.Products?.map((product, index) => `
    <div style="font-weight:bold;">${index + 1}. ${product.productName}<br/>${product.arabicword ? `<span style="font-size: 10px; margin-left: 10px; font-style: italic; font-family: 'Tahoma', sans-serif;">${product.arabicword}</span>` : ""}</div>
    <div style="display:flex; justify-content:space-between;  padding-left:10px;">
      <div>${product.quantity} ${product.uom || ""} X ${roundAmount(product.amount)}</div>
      <div>${roundAmount(product.quantity * product.amount)}</div>
    </div>

  ${product.addOns && product.addOns.length > 0 ? product.addOns.map((s) => `
    <div style="display:flex; justify-content:space-between; font-size:12px; padding-left:10px;">
      <div>${s.text}</div>
      <div>${roundAmount(s.amount)}</div>
    </div>
      `,).join("") : ""}
      <br/>`,).join("")}</div>`;
  };

  const normalDesign = () => {
    return `
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 5px; border-bottom: 1px dashed #000;">
      <thead style="border-bottom: 1px dashed #000;">
        <tr>
          <th class="col-no">#</th>
          <th class="col-name">Product Name</th>
          <th class="col-qty">Qty</th>
          <th class="col-price">Price</th>
          <th class="col-total">Total</th>
        </tr>
      </thead>
      <tbody>
        ${PrintData?.Products?.map(
      (p, index) => `
          <tr>
          <td class="col-no" style>${index + 1}</td>
              <td class="col-name">
              ${p.productName}
              <br/>
              <span style="font-size: 10px; font-style: italic; font-family: 'Tahoma', sans-serif;">
                ${p.arabicword ?? ""}
              </span>
            </td>
            <td class="col-qty">${p.quantity}${PrintData?.businessType === "Grocery" ? p.uom?.substring(0, 3).toLowerCase() : ""}</td>
            <td class="col-price">${roundAmount(p.amount)}</td>
            <td class="col-total">${roundAmount(p.totalPrice)}</td>
          </tr>
          ${p.addOns && p.addOns.length > 0
          ? p.addOns
            .map(
              (s, sIndex) => `
              
              <!-- SERVICE ROW -->
              <tr>
                <td></td>
                
                <td style="padding-left:20px;font-size:11px;">
                  ${sIndex + 1} ${s.text}
                </td>

                <td></td>

                <td style="font-size:11px;">
                  ${roundAmount(s.amount)}
                </td>

                <td style="font-size:11px;">
                  
                </td>
              </tr>
            `,
            )
            .join("")
          : ""
        }
        `,
    ).join("") || ""
      }
      </tbody>
    </table>`;
  };

  const carwashorderdetails = () => {
    const printDataAny = PrintData as any;
    const cars = printDataAny?.cars || [];
    const allProducts = PrintData?.Products || [];

    if (cars.length === 0 && allProducts.length === 0) {
      return "<div>No order data available</div>";
    }

    const formatPrice = (price: any) => {
      const num = Number(price);
      return isNaN(num) ? "0.00" : num.toFixed(2);
    };

    let vehiclesCount = 0;
    let grandTotal = 0;

    const carsHtml = cars
      .map((car: any, index: number) => {
        vehiclesCount++;
        let carSubtotal = 0;

        const products = car?.services?.[0]?.productDetails || [];

        if (products.length === 0) return "";

        const productRows = products
          .map((product: any) => {
            const price = Number(product.price) || 0;
            carSubtotal += price;
            grandTotal += price;

            return `
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <div style="padding-left: 15px;">${product.product || ""}</div>
              <div>${formatPrice(price)}</div>
            </div>
          `;
          })
          .join("");

        return `
        <div style="margin-top: 12px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${car.carNumber || `CAR-${index + 1}`}</div>
          ${productRows}
          <div style="display: flex; justify-content: space-between; padding: 4px 0; border-top: 1px dotted #ccc; margin-top: 4px; font-weight: bold;">
            <div>Car ${index + 1} Subtotal</div>
            <div>${formatPrice(carSubtotal)}</div>
          </div>
        </div>
      `;
      })
      .join("");

    return `
    <div style="margin: 15px 0;">
      <div style="font-weight: bold; margin-bottom: 15px; text-align: center;">
        MULTI-CAR ORDER - ${vehiclesCount} VEHICLES
      </div>
      
      ${carsHtml}
      
      <div style="border-top: 1px solid #000; margin: 15px 0 10px;"></div>
      
      <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
        <div>Vehicles:</div>
        <div>${vehiclesCount} cars</div>
      </div>
      
      <div style="display: flex; justify-content: space-between; font-weight: bold;">
        <div>Total:</div>
        <div>${formatPrice(grandTotal)}</div>
      </div>
    </div>
  `;
  };

  const businessTypes = user?.businessType || "";

  /** ===============================
   * RECEIPT HTML CONTENT
   * =============================== */
  const content = `
  <div class="receipt-content" style="font-family: Arial, sans-serif; width: 100%; padding: 5px;">

    ${companyData(comLogo)}
    ${PrintData ? orderData() : ""}
    ${PrintData ? customerData() : ""}
    ${ledgerPaid ? ledgerList() : ""}
    ${PrintData ? (businessTypes === "Carwash" ? carwashorderdetails() : "") : ""}
    ${PrintData ? (businessTypes !== "Carwash" ? orderDetails() : "") : ""}
    ${PrintData?.returnProducts && PrintData.returnProducts.length > 0 ? returnDetails() : ""}
    ${PrintData?.payMentHistoryAvabile ? printHistory() : ""}
    ${barcodeTrue ? `<div style="text-align:center; margin-top:10px;"><img src="${barcodeDataUrl}" style="width:200px; height:50px;" /></div>` : ""}
    ${enabileTermsAndConditions && userConfigration.enableTermsAndConditions && userConfigration.termsAndConditionsEnglish ? `<div style="margin-top:10px; border-top:1px solid #e5e7eb;"><strong>Terms and Conditions:</strong><p>${formatTerms(userConfigration.termsAndConditionsEnglish)}</p></div>` : ""}
    ${enabileTermsAndConditions && userConfigration.enableTermsAndConditions && userConfigration.termsAndConditionsArabic ? `<div style="margin-top:10px; font-size:14px;"><p>${formatTerms(userConfigration.termsAndConditionsArabic)}</p></div>` : ""}
    ${userConfigration?.contact_qr_codeAWS ? `<div style="text-align:center; margin-top:10px;"><strong>Contact QR Code:</strong><img src="${userConfigration.contact_qr_codeAWS}" style="width:160px; height:160px;" /></div>` : ""}
    ${userConfigration?.location_qr_codeAWS ? `<div style="text-align:center; margin-top:10px;"><strong>Location QR Code:</strong><img src="${userConfigration.location_qr_codeAWS}" style="width:160px; height:160px;" /></div>` : ""}
    <div style="text-align:center; margin-top:6px; border-top: 1px solid black; padding-top:5px;">
     <p>Thanks for visiting ${user?.orgName || COMPANY_NAME}</p>
      <p>Powered by ${COMPANY_NAME}</p>
    </div>

  </div>
  `;

  /**===============================
   * Print HTML STRUCTURE
   * =============================== */

  const copies = 1;

  const printData = `${printerCheck}
  <body>
  ${Array.from({ length: copies })
      .map(
        (_, index) => `
      <div class="page ${index < copies - 1 ? "copy-break" : ""}">
        ${content}
      </div>
    `,
      )
      .join("")}

</body>
</html>`;
  /** ===============================
   * PRINTING SYSTEM (AUTO PAPER SIZE)
   * =============================== */
  const handlePrint = () => {
    if (toBoolean(userConfigration.appPrinterEnabled) === true) {
      handleAppPrint?.(printData);
    } else {
      // alert("Please select a printer in the printer configuration to enable printing.");
      if (isDisabled) return;
      setIsDisabled(true);

      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const printDoc = iframe.contentWindow?.document;

      if (printDoc) {
        printDoc.open();
        printDoc.write(printData);
        printDoc.close();

        const cleanup = () => {
          try {
            if (document.body.contains(iframe)) document.body.removeChild(iframe);
          } catch (e) { }
          setIsDisabled(false);
        };

        iframe.onload = () => {
          try {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();
          } catch (e) { }

          const onAfterPrint = () => {
            try {
              isClosed?.(false);
            } catch (e) { }
            cleanup();
            try {
              iframe.contentWindow?.removeEventListener("afterprint", onAfterPrint);
            } catch (e) { }
          };

          try {
            iframe.contentWindow?.addEventListener("afterprint", onAfterPrint);
          } catch (e) { }

          setTimeout(() => {
            if (document.body.contains(iframe)) {
              try {
                isClosed?.(false);
              } catch (e) { }
              cleanup();
            }
          }, 2000);
        };
      }
    }
  };

  /** BARCODE GENERATION */
  useEffect(() => {
    if (PrintData?.OrderId) {
      const canvas = document.createElement("canvas");
      JsBarcode(canvas, String(PrintData.OrderId), {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: false,
      });
      setBarcodeDataUrl(canvas.toDataURL("image/png"));
    }
  }, [PrintData?.OrderId]);

  /** AUTO PRINT */
  useEffect(() => {
    if (!openPrint) return;
    // if barcode is expected, wait until it's generated
    if (barcodeTrue && !barcodeDataUrl) return;
    // If ledgerPaid is provided or PrintData is present, proceed
    handlePrint();
  }, [openPrint, barcodeDataUrl, barcodeTrue, ledgerPaid]);

  return (
    <div>
      {(BtnName || icon) &&
        (user?.businessType === "Grocery" ? (
          <Button className={className} label={BtnName} onClick={handlePrint} icon={icon} radius="rounded-full" font="font-bold" />
        ) : (
          <CommonButtons label={BtnName} onClick={handlePrint} icon={icon} className={className} />
        ))}
    </div>
  );
};

export default ThermalPrint3;